import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ServiceWorkerModule } from '@angular/service-worker';

import { PWA_PROVIDERS } from '@core/modules/pwa/pwa.config';

@NgModule({
  imports: [
    // Angular imports
    CommonModule,
    ServiceWorkerModule.register('ngsw-worker.js'),
  ],
  providers: [...PWA_PROVIDERS],
})
export class PWAModule {}
